import React from "react";
import PropTypes from "prop-types";
import {Redirect, Route} from "react-router-dom";

const PrivateRoute = ({component: Component, auth, requirePermission, exact, path, ...rest}) => (
  <Route
    exact={exact}
    path={path}
    render={props =>
      auth.isAuthenticated() ?
        !requirePermission || auth.hasPermission(requirePermission) ? (
          <Component {...props} {...rest} />
        ) : (
          <div>Permission denied</div>
        )
        : (
          <Redirect to={{
            pathname: "/login",
            state: {from: props.location}
          }}/>
        )
    }
  />
);
PrivateRoute.propTypes = {
  component: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  requirePermission: PropTypes.string,
  exact: PropTypes.bool,
  path: PropTypes.string.isRequired,
  location: PropTypes.object,
};
export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/PrivateRoute.js